<div class="accounting-popup" role="dialog" aria-label="Cuentas contables">
  <div class="accounting-popup__container">
    <!-- Header: solo título y cerrar -->
    <div class="accounting-popup__header">
      <h3 class="accounting-popup__title">Cuentas Contables</h3>
      <button type="button" class="accounting-popup__close" (click)="onClose()" aria-label="Cerrar">
        ✕
      </button>
    </div>

    <!-- Contenido: solo la tabla -->
    <div class="accounting-popup__content">
      @if (loading()) {
        <div class="loading-bar">
          <div class="loading-bar-inner"></div>
        </div>
      }

      @if (error()) {
        <div class="error-message">
          <span class="error-icon">⚠</span>
          <p>{{ error() }}</p>
        </div>
      }

      @if (!loading() && !error()) {
        @if (formattedCuentasContables().length > 0) {
          <app-data-table-wrapper
            [tableConfig]="cuentasContablesTableConfig()"
            [data]="formattedCuentasContables()"
            [loading]="false"
            [showPagination]="false"
          >
          </app-data-table-wrapper>
        } @else {
          <div class="empty-state">
            <p>{{ 'ACCOUNTING.ACCOUNTING_FORMAT.EMPTY.NO_ACCOUNTS' | translate }}</p>
            <small>{{
              'ACCOUNTING.ACCOUNTING_FORMAT.EMPTY.NO_ACCOUNTS_DESCRIPTION' | translate
            }}</small>
          </div>
        }
      }
    </div>
  </div>
</div>
